import store from './store.js';

export default {
    data() {
        return {}
    },
    computed: {
        signedInUser() {
            return store.state.PermissionsModule.signedInUser;
        },
        activeRoute() {
            return this.$route.name;
        },
    },
    methods: {
        setActiveItem() {
            let menuItems = document.querySelectorAll('.e-menu-item');

            menuItems.forEach((item) => {
                if (item.id === this.activeRoute) {
                    item.classList.add('app-sidebar-selected');
                } else {
                    item.classList.remove('app-sidebar-selected');
                }
            })
        },
        routeToSurvey() {
            DMUtils.setCookie('ita-token', DMUtils.getAuthToken(), '/', window.cookieDomain);
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.href = window.surveyUrl + '/?refresh=token';
            a.click();
            document.body.removeChild(a);
        },
        routeToDashboards(openInNewTab = false) {
            DMUtils.setCookie('ita-token', DMUtils.getAuthToken(), '/', window.cookieDomain);
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.href = window.resultsUrl + '?toPage=summary&refresh=token';

            if (openInNewTab) {
                a.target = '_blank';
            }

            a.click();
            document.body.removeChild(a);
        },
        checkAndRouteUser(user) {
            store.commit('PermissionsModule/setSignedInUser', user);

            if (user.Role === '') {
                this.routeToSurvey();
                return;
            }

            if (user.Role.toLowerCase().includes('dashboard')) {
                if (user.HasSurvey) {
                    this.routeToSurvey();
                    return;
                } else {
                    this.routeToDashboards();
                    return;
                }
            }

            return store.dispatch('PermissionsModule/getPermissionsForUser')
                .then(() => {
                    store.commit('PermissionsModule/setLandingPage');
                    
                    if (!this.activeRoute || this.activeRoute === 'signIn') {
                        this.$router.push({ name: store.state.PermissionsModule.landingPage });
                    }
    
                    this.setActiveItem();  
                })
        }
    }
}